module.exports = require('./v8.min.json');



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl-style-spec/reference/latest.min.js
 ** module id = 382
 ** module chunks = 0
 **/